import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const NoticesPage = lazy(() => import('./NoticesPage'));

const NoticesRoute: FuseRouteItemType = {
	path: 'notices',
	element: <NoticesPage />,
	settings: {
		layout: {
			config: {
				toolbar: {
					showTitle: false,
					showCrumbs: false,
				}
			}
		}
	}
};

export default NoticesRoute;
